import React from 'react'
import '../guia-de-estilos.css'

const tipografia = () => {
  return (
    <div className='container-fluid d-flex justify-content-center pb-5 border-bottom border-3'>
      <div className='container p-0 mt-3'>
        <div className='container-lg p-0'>
          <div className='py-3'>
            <p className='short-title font-semibold text-premium-blue mt-4'>Tipografía: Garnett</p>
            <p className='sub-title text-premium-blue'>Garnett-Semibold & Garnett-Regular </p>
          </div>
          <div className='row mt-3 column-gap-3 row-gap-3'>
            <div className='col text-premium-blue'>
              <div className='text-mexican-pink mb-3'>
                <p className='sub-title'>Descripción</p>
              </div>
              <div>
                <p className='short-title font-semibold'>Título corto</p>
                <p>Semibold, font-size: 49px / line-height: 52px </p>
              </div>
              <div>
                <p className='logn-title font-semibold'>Título largo</p>
                <p>Semibold, font-size: 44px / line-height: 48px </p>
              </div>
              <div>
                <p className='sub-title'>Sub-Título</p>
                <p>Regular, font-size: 24px / line-height: 32px </p>
              </div>
              <div>
                <p>------------</p>
              </div>
              <div>
                <p className='amc-text'>Texto</p>
                <p>Regular, font-size: 16px / line-height: 23px </p>
              </div>
              <div>
                <p className='amc-notes'>Notas</p>
                <p>Regular, font-size: 9px / line-height: 13px </p>
              </div>
              <div>
                <p className='micro-title font-semibold'>Micro-título</p>
                <p>.micro-title .font-semibold</p>
              </div>
            </div>
            <div className='col text-premium-blue d-none d-lg-block'>
              <div className='text-mexican-pink mb-3'>
                <p className='sub-title'>Ejemplos</p>
              </div>
              <div>
                <p className='short-title font-semibold'>Ejemplo de título corto.</p>
                <p>.short-title .font-semibold</p>
              </div>
              <div>
                <p className='logn-title font-semibold'>Ejemplo de título largo.</p>
                <p>.logn-title .font-semibold</p>
              </div>
              <div>
                <p className='sub-title'>Este es un ejemplo de sub-título.</p>
                <p>.sub-title</p>
              </div>
              <div>
                <p>------------</p>
              </div>
              <div>
                <p className='amc-text'>Este es un ejemplo de texto. Lorem ipsum dolor sit amet.</p>
                <p>.amc-text</p>
              </div>
              <div>
                <p className='amc-notes'>Este es un ejemplo de nota: Del 30 de noviembre de 2022 al 15 de enero de 2023.</p>
                <p>.amc-notes</p>
              </div>
              <div>
                <p className='micro-title font-semibold'>Ejemplo micro-título.</p>
                <p>.micro-title .font-semibold</p>
              </div>
            </div>        
          </div>
        </div>
      </div>
    </div>
  )
}

export default tipografia